import axios from "axios";
import * as config from "./../config/config";
import api from "./interceptor";
let isDownloading = false;

export async function getall_facture({ start, end } = {}) {
  try {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_FACTURE, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_ListeEcheances({ start, end } = {}) {
  try {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_FACTURE_ECHEANCES, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function toggle_facture(facture_id, statut_facture) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_TOGGLE_FACTURE + facture_id,
      {
        statut_facture: statut_facture,
        user_id: localStorage.getItem('user_id')
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function download_facture(facture) {
  try {
    if (isDownloading) return;
    isDownloading = true;

    const response = await api.get(
      config.REACT_APP_ENDPOINT_DOWNLOAD_FACTURE + facture.id,
      {
        responseType: "blob",
        timeout: 1000000
      }
    );

    const url = window.URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = url;

    // 🔥 récupère vrai nom fichier depuis backend
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "facture.pdf";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match) fileName = match[1];
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

  } catch (error) {
    console.error("Erreur download :", error);
    throw error;
  } finally {
    isDownloading = false;
  }
}

export async function add_acompte(data) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_ADD_ACOMPTE + data['facture_id'],
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_acompte(facture_id) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_LISTE_ACOMPTE,
      {
        "facture_id": facture_id
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function export_factures(params) {
  try {
    const response = await api.get(
      `${config.REACT_APP_ENDPOINT_EXPORT_FACTURES}?${params.toString()}`,
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `factures_export.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    return 1
  } catch (error) {
    throw error;
    return 0
  }
}